import en from './en'

export default { en }